module.exports = __webpack_public_path__ + "img/CreateCustomRules.8989e43.svg";